import { Box, TextField, Typography, InputAdornment, Stack } from "@mui/material";
import { FC } from "react";
import { IInvoiceData } from "../InvoicePage";

interface OrdererFormProps {
    invoiceData: IInvoiceData;
    setInvoiceData: (data: IInvoiceData) => void;
}

const getToday = () => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
};


const OrdererForm: FC<OrdererFormProps> = ({ invoiceData, setInvoiceData }) => {
    const handleChange = (field: string, value: any) => {
        if (field.startsWith("ordererAddress.")) {
            const addressField = field.split(".")[1];
            setInvoiceData({
                ...invoiceData,
                ordererAddress: {
                    ...invoiceData.ordererAddress,
                    [addressField]: value,
                },
            });
        } else {
            setInvoiceData({
                ...invoiceData,
                [field]: value,
            });
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", mt: 6, mb: 4 }}>
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "1086px",
                    background: "#fff",
                    borderRadius: 3,
                    boxShadow: 5,
                    p: 4,
                }}
            >
                <Typography variant="h5" sx={{ mb: 3, fontWeight: 700, textAlign: "center", letterSpacing: 1 }}>
                    Dane zamawiającego
                </Typography>
                <Stack spacing={2}>
                    <TextField
                        label="Nazwa"
                        fullWidth
                        value={invoiceData.ordererName}
                        onChange={e => handleChange("ordererName", e.target.value)}
                        variant="outlined"
                    />
                    <TextField
                        label="NIP"
                        fullWidth
                        value={invoiceData.ordererNIP || ""}
                        onChange={e => handleChange("ordererNIP", e.target.value)}
                        variant="outlined"
                    />
                    <Stack direction="row" spacing={2}>
                        <TextField
                            label="Ulica"
                            fullWidth
                            value={invoiceData.ordererAddress.street}
                            onChange={e => handleChange("ordererAddress.street", e.target.value)}
                            variant="outlined"
                        />
                        <TextField
                            label="Numer domu"
                            fullWidth
                            value={invoiceData.ordererAddress.houseNumber}
                            onChange={e => handleChange("ordererAddress.houseNumber", e.target.value)}
                            variant="outlined"
                        />
                        <TextField
                            label="Numer mieszkania"
                            fullWidth
                            value={invoiceData.ordererAddress.apartmentNumber}
                            onChange={e => handleChange("ordererAddress.apartmentNumber", e.target.value)}
                            variant="outlined"
                        />
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            label="Kod pocztowy"
                            fullWidth
                            value={invoiceData.ordererAddress.postalCode}
                            onChange={e => {
                                let val = e.target.value.replace(/[^0-9-]/g, "");
                                if (val.length === 2 && !val.includes("-")) val += "-";
                                handleChange("ordererAddress.postalCode", val);
                            }}
                            variant="outlined"
                            inputProps={{ maxLength: 6 }}
                        />
                        <TextField
                            label="Miejscowość"
                            fullWidth
                            value={invoiceData.ordererAddress.city}
                            onChange={e => handleChange("ordererAddress.city", e.target.value)}
                            variant="outlined"
                        />
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            label="Email"
                            fullWidth
                            value={invoiceData.ordererEmail}
                            onChange={e => handleChange("ordererEmail", e.target.value)}
                            variant="outlined"
                            type="email"
                        />
                        <TextField
                            label="Telefon"
                            fullWidth
                            value={invoiceData.ordererPhone}
                            onChange={e => handleChange("ordererPhone", e.target.value)}
                            variant="outlined"
                            type="tel"
                            InputProps={{
                                startAdornment: <InputAdornment position="start">+48</InputAdornment>,
                            }}
                        />
                    </Stack>
                    <TextField
                        label="Data"
                        type="date"
                        fullWidth
                        value={invoiceData.date && !isNaN(Date.parse(invoiceData.date)) ? invoiceData.date : getToday()}
                        onChange={e => {
                            const value = e.target.value;
                            handleChange(
                                "date",
                                value && !isNaN(Date.parse(value)) ? value : getToday()
                            );
                        }}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                    />
                </Stack>
            </Box>
        </Box>
    );
};

export default OrdererForm;